import { EditForm } from "./CaptureFormContainer";

export const formConfig: {
  label: string;
  field: keyof EditForm;
}[] = [{
  label: "Name",
  field: "fullName"
}, {
  label: "Email",
  field: "email"
}, {
  label: "Phone",
  field: "phone"
}, {
  label: "Country",
  field: "country"
}, {
  label: "City",
  field: "city"
}];